import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
  getList(params) { //获取授权产品列表
    const url =  baseURL + '/tbAuthorizedproduct/getList';
    return axios.post(url, qs.stringify(params));
  },
  getListNew(params) { //获取授权产品列表
    const url =  baseURL + '/tbAuthorizedproduct/getListNew';
    return axios.post(url, qs.stringify(params));
  },
  setProduct(params) { //企业用户分配产品
    const url =  baseURL + '/tbAuthorizedproduct/companyProductDistribute';
    return axios.post(url, qs.stringify(params));
  },
  delProduct(params) { //企业用户分配产品 撤销
    const url =  baseURL + '/tbAuthorizedproduct/companyProductDistributeCancel';
    return axios.post(url, qs.stringify(params));
  },

  // 撤销分配产品给部门
  delProductDepart(params) { 
    const url =  baseURL + '/tbDept/deptProductCancle';
    return axios.post(url, qs.stringify(params));
  },

  // 产品分配给部门
  dispatchProductToDepart(params){
    const url =  baseURL + '/tbAuthorizedproduct/auProToDeptManager';
    return axios.post(url, qs.stringify(params));
  },

   


  
  
}


// WEBPACK FOOTER //
// ./src/api/wePro.js